import { render, staticRenderFns } from "./RevokeModalDefault.vue?vue&type=template&id=7bbc0002&scoped=true"
import script from "./RevokeModalDefault.vue?vue&type=script&lang=js"
export * from "./RevokeModalDefault.vue?vue&type=script&lang=js"
import style0 from "./RevokeModalDefault.vue?vue&type=style&index=0&id=7bbc0002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbc0002",
  null
  
)

export default component.exports